import { useState } from 'react'
import Chat from '../chat/Chat'
import MyTransactions from '../transactions/MyTransactions'
import { useSelector } from 'react-redux'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

const ActivityPanel = () => {
  const { chat } = useSelector((state) => state.configurations.featureToggles)
  const isDesktop = useSelector((state) => state.layout.mode) === INTERNAL_CONSTANTS.DEVICES.DESKTOP

  // Chat only docks in the activity panel on desktop (mobile/tablet use the
  // header button + full-screen overlay), so the Chat tab is desktop-only.
  const isChatTabEnabled = chat && isDesktop

  const ACTIVITY_PANEL_CONTENT = {
    MY_TRANSACTIONS: {
      KEY: 'MY_TRANSACTIONS',
      TAB_NAME: 'My Transactions',
      COMPONENT: <MyTransactions />,
      IS_ENABLE: true,
    },

    CHAT: {
      KEY: 'CHAT',
      TAB_NAME: 'Chat',
      // Chat is rendered as a persistent layer below (not swapped tab content),
      // so it isn't listed here as a COMPONENT.
      COMPONENT: null,
      IS_ENABLE: isChatTabEnabled,
    },
  }

  const TABS = Object.values(ACTIVITY_PANEL_CONTENT).filter(({ IS_ENABLE }) => IS_ENABLE)

  const [currentActivityTab, setCurrentActivityTab] = useState(TABS[0].KEY)
  const [slideDirection, setSlideDirection] = useState(1)

  const activeIndex = TABS.findIndex((tab) => tab.KEY === currentActivityTab)
  const activeTab = ACTIVITY_PANEL_CONTENT[currentActivityTab]
  const isChatActive = currentActivityTab === 'CHAT'

  const handleTabChange = (nextKey) => {
    if (nextKey === currentActivityTab) return
    const nextIndex = TABS.findIndex((tab) => tab.KEY === nextKey)
    setSlideDirection(nextIndex >= activeIndex ? 1 : -1)
    setCurrentActivityTab(nextKey)
  }

  return (
    <div className="standard-normal-activity-panel-outer-container">
      <div className="standard-normal-activity-panel-inner-container">
        <div
          className="standard-normal-activity-panel-tabs-container"
          style={{
            '--activity-tab-count': TABS.length,
            '--activity-tab-index': activeIndex,
          }}
        >
          {TABS.map((tab) => (
            <div
              key={tab.KEY}
              className={`standard-normal-activity-panel-tab ${tab.KEY === currentActivityTab ? 'standard-normal-activity-panel-active-tab' : ''} `}
              onClick={() => handleTabChange(tab.KEY)}
            >
              {tab.TAB_NAME}
            </div>
          ))}

          <span className="standard-normal-activity-panel-tab-indicator" aria-hidden="true" />
        </div>

        <div className="standard-normal-activity-panel-content-container">
          {/* Non-chat tabs animate in/out as usual. */}
          {!isChatActive && (
            <div
              key={currentActivityTab}
              className="standard-normal-activity-panel-content"
              style={{ '--activity-slide-direction': slideDirection }}
            >
              {activeTab.COMPONENT}
            </div>
          )}

          {/* Chat is mounted once and preloads in the background; only its
              visibility follows the active tab, so switching tabs never drops
              the chat socket. */}
          {isChatTabEnabled && <Chat visible={isChatActive} />}
        </div>
      </div>
    </div>
  )
}

export default ActivityPanel
